import {
  mapGetReportHistoryResponseType,
  useGetReportHistorySuspense,
} from '@api';
import { ReportHistoryTable } from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Route } from 'src/routes/_rootLayout/persons/$id.reports';
import { useMarkReportHistoryEntryAsReviewed } from './hooks';

export const PersonReportHistory: React.FC = () => {
  const { id } = Route.useParams();
  const { hasPermission } = usePermissionContext();
  const { data: entries } = useGetReportHistorySuspense(
    { personId: id },
    {
      query: {
        select: (response) => mapGetReportHistoryResponseType(response).results,
      },
    }
  );
  const { markAsReviewed, pendingEntryId } =
    useMarkReportHistoryEntryAsReviewed();

  const canReview = hasPermission({ permission: 'REPORTS', action: 'WRITE' });

  return (
    <ReportHistoryTable
      variant="PERSON"
      entries={entries}
      canReview={canReview}
      pendingEntryId={pendingEntryId}
      onMarkAsReviewed={markAsReviewed}
    />
  );
};
